export default __webpack_public_path__ + "static/img2-27cd76c155877384126bb5819501bade.png";